import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';
import ready from '../components/_ready';

const key = 'true';
export default function modalPopup() {
  const modalPopupElement = document.getElementById('modalPopup');
  const modalCloseElement = document.querySelector('.close-popup');
  const modalDialog = document.getElementById('modal-dialog-popup');
  const contentBody = document.getElementById('body-main');

  setTimeout(() => {
    modalPopupElement.style.display = 'block';
    contentBody.classList.add('overflow-hidden');
    Velocity(modalDialog, 'transition.fadeIn', { duration: '2400' });
  }, 1000);

  modalCloseElement.addEventListener('click', () => {
    Velocity(modalDialog,
      'transition.fadeOut',
      {
        complete: () => {
          contentBody.classList.remove('overflow-hidden');
          modalPopupElement.style.display = 'none';
        },
      });
    localStorage.setItem(key, 'false');
  });
}

function setTrue(element) {
  if (element) {
    element.addEventListener('click', () => {
      localStorage.setItem(key, 'true');
    });
  }
}

ready(() => {
  const login = document.querySelector('.btn-login');
  if (login) {
    localStorage.setItem(key, 'true');
  }
  setTrue(login);
  if (localStorage.getItem(key) === 'true') {
    modalPopup();
  }
});
